import { render, staticRenderFns } from "./TasksNotificationDropDown.vue?vue&type=template&id=9e3640d0&"
import script from "./TasksNotificationDropDown.vue?vue&type=script&lang=js&"
export * from "./TasksNotificationDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports